import { get } from "../../helpers/api_helper"

export const fetchUser = data => {
    return get(
      `user/fetch/${data?.id}${
        data?.type ? `?extra=${data?.type}` : ""
      }`
    )
  }